import AddIcon from "@mui/icons-material/Add";
import { Grid2, IconButton, Tooltip } from "@mui/material";
import React from "react";
import RelatedItem from "../RelatedItem";
import { RelatedModal } from "../index";
import "./styles.scss";
import { useSelector } from "react-redux";
import { currentUserSelector } from "../../login/logic/actions";
import { isReadOnlyRole } from "../../login/logic/sagas";

const RelatedTable = (props) => {
    const { associations, toggleRelatedFilmsForm, changeAssociations, advId } = props;
    const user = useSelector(currentUserSelector);
    const toggleForm = () => {
        toggleRelatedFilmsForm();
    };

    return (
        (<Grid2 container className="related-table">
            {}
            <Grid2
                className="table-header"
                size={{
                    xs: 12,
                    md: 12
                }}>
                {!isReadOnlyRole(user) && <Grid2 size={1}>
                    <Tooltip title="Add Association">
                        <IconButton size="small" onClick={toggleForm}>
                            <AddIcon />
                        </IconButton>
                    </Tooltip>
                </Grid2>}
                <Grid2 paddingTop={2}
                    size={{
                        xs: 8,
                        md: 8
                    }}>
                    Related Films
                </Grid2>
                <Grid2
                    size={{
                        xs: 3,
                        md: 3
                    }}>
                    Type
                </Grid2>
            </Grid2>
            <Grid2
                className="table-body"
                style={{
                    maxHeight: "225px",
                }}
                size={{
                    xs: 12,
                    md: 12
                }}>
                {associations.map((item) => (
                    <RelatedItem key={item.filmRelease.title} item={item} />
                ))}
            </Grid2>
            <RelatedModal advId={advId} changeAssociations={changeAssociations} associations={associations} />
        </Grid2>)
    );
};

export default RelatedTable;
